
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index0gLql_EGmfBAVheG9geHNwiithIctaLKZxYsav5FLSAMeta } from "/tmp/tmps5w5t0mf/pages/index.vue?macro=true";
import { default as index28jqN6aEwGdHq7xXmKIEnLSAKkISRjL8Jhwf4dkEZxAMeta } from "/tmp/tmps5w5t0mf/pages/[rvrsys]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmps5w5t0mf/pages/index.vue")
  },
  {
    name: "rvrsys",
    path: "/:rvrsys()",
    component: () => import("/tmp/tmps5w5t0mf/pages/[rvrsys]/index.vue")
  }
]